<template>
  <el-dialog
    title="添加岗位"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
    style="margin-top: -5%;"
  >
    <div class="product-add pb50">
      <el-form 
        ref="formRef" 
        :model="form" 
        :rules="rules" 
        label-width="120px"
        size="small"
      >
        <!-- 第一行：所属部门和岗位名称 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属部门" prop="ma_depart_id" required>
              <el-select 
                v-model="form.ma_depart_id" 
                placeholder="请选择所属部门"
                style="width: 100%;"
                clearable
                filterable
              >
                <el-option
                  v-for="dept in departmentList"
                  :key="dept.ma_depart_id"
                  :label="dept.name"
                  :value="dept.ma_depart_id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="岗位名称" prop="name" required>
              <el-input 
                v-model="form.name" 
                placeholder="请输入岗位名称"
                maxlength="50"
                show-word-limit
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="负责人岗" prop="is_leader" required>
              <el-radio-group v-model="form.is_leader">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第三行：岗位编码 -->
        <el-form-item label="岗位编码" prop="code" required>
          <el-input 
            v-model="form.code" 
            placeholder="请输入岗位编码（如：MANAGER）"
            maxlength="50"
            show-word-limit
          />
        </el-form-item>

        <!-- 第四行：岗位职能 -->
        <el-form-item label="岗位职能" prop="description" required>
          <el-input 
            v-model="form.description" 
            type="textarea"
            :rows="3"
            placeholder="请输入岗位职能描述"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>

        <!-- 第五行：其他职能（多选） -->
        <el-form-item label="其他职能" prop="other_functions">
          <el-checkbox-group v-model="form.other_functions_selected">
            <el-checkbox label="安全承诺书" />
            <el-checkbox label="安全生产责任制" />
            <el-checkbox label="岗位危险及职业危害告知书" />
            <el-checkbox label="其他">
              <el-input 
                v-if="form.other_functions_selected.includes('其他')"
                v-model="form.other_functions_custom" 
                placeholder="请输入其他职能"
                style="width: 200px; margin-left: 10px;"
                size="mini"
              />
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-tabs v-model="activeType">
          <el-tab-pane label="安全承诺书" name="0"></el-tab-pane>
          <el-tab-pane label="安全生产责任制" name="1"></el-tab-pane>
          <el-tab-pane label="岗位危险及职业危害告知书" name="2"></el-tab-pane>
        </el-tabs>

        <!-- 安全承诺内容 -->
        <el-form-item prop="safety_commitment" v-if="activeType == '0'">
          <el-input 
            v-model="form.safety_commitment" 
            type="textarea"
            :rows="9"
            placeholder="请输入安全承诺内容"
            maxlength="2000"
            show-word-limit
          />
        </el-form-item>

        <!-- 安全生产责任制内容 -->
        <el-form-item prop="safety_responsibility" v-if="activeType == '1'">
          <el-input 
            v-model="form.safety_responsibility" 
            type="textarea"
            :rows="9"
            placeholder="请输入安全生产责任制内容"
            maxlength="1000"
            show-word-limit
          />
        </el-form-item>

        <!-- 岗位危险告知 -->
        <el-form-item prop="hazard_information" v-if="activeType == '2'">
          <el-input 
            v-model="form.hazard_information" 
            type="textarea"
            :rows="9"
            placeholder="请输入岗位危险及职业危害告知书内容"
            maxlength="1000"
            show-word-limit
          />
        </el-form-item>

     
        <!-- 状态 -->
        <el-form-item label="状态" prop="status">
          <el-switch
            v-model="form.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="停用"
          />
        </el-form-item>

 
        <!-- 提交按钮 -->
        <div class="common-button-wrapper" style="text-align: center; margin-top: 30px;">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      
      <!-- 图片上传组件 -->
      <Upload 
        v-if="isProductUpload" 
        :config="{ total: 9 }" 
        :isupload="isProductUpload" 
        @returnImgs="returnProductImgsFunc"
      />
    </div>
  </el-dialog>
</template>

<script>
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';

export default {
  components: {
    Upload
  },
  data() {
    return {
      activeType: '0',
      dialogVisible: false,
      isProductUpload: false,
      uploadType: 'image',
      loading: false,
      
      // 数据列表
      departmentList: [],
      positionList: [],
      
      // 表单数据
      form: {
        ma_depart_id: '',
        parent_id: 0,
        name: '',
        code: '',
        description: '',
        is_leader: 0,
        status: 1,
        sort: 100,
        is_hide: 0,
        other_functions_selected: [],
        other_functions_custom: '',
        safety_commitment: '',
        safety_responsibility: '',
        hazard_information: '',
        intro: '',
        image: [],
        bannar: []
      },
      
      // 验证规则
      rules: {
        ma_depart_id: [
          { required: true, message: '请选择所属部门', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入岗位名称', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入岗位编码', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入岗位职能描述', trigger: 'blur' }
        ],
        is_leader: [
          { required: true, message: '请选择是否负责人岗', trigger: 'change' }
        ]
      }
    };
  },
  props: ["open_add"],
  created() {
    this.dialogVisible = this.open_add;
    this.initForm();
    this.loadDepartments();
    this.loadPositions();
  },
  methods: {
    // 初始化表单
    initForm() {
      this.form = {
        ma_depart_id: '',
        parent_id: 0,
        name: '',
        code: '',
        description: '',
        is_leader: 0,
        status: 1,
        sort: 100,
        is_hide: 0,
        other_functions_selected: [],
        other_functions_custom: '',
        safety_commitment: '',
        safety_responsibility: '',
        hazard_information: '',
        intro: '',
        image: [],
        bannar: []
      };
      
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate();
      }
    },
    
    // 加载部门列表 - 使用通用API
    async loadDepartments() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'index',
          page: 1,
          list_rows: 1000
        });
        
        if (response.code === 1 && response.data.list) {
          this.departmentList = response.data.list.data || [];
        }
      } catch (error) {
        console.error('加载部门列表失败:', error);
        this.$message.error('加载部门列表失败');
      }
    },
    
    // 加载岗位列表 - 使用通用API
    async loadPositions() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_position',
          action: 'index',
          page: 1,
          list_rows: 1000
        });
        
        if (response.code === 1 && response.data.list) {
          this.positionList = response.data.list.data || [];
        }
      } catch (error) {
        console.error('加载岗位列表失败:', error);
      }
    },
    
    // 打开图片上传
    openProductUpload(type) {
      this.uploadType = type;
      this.isProductUpload = true;
    },
    
    // 接收上传的图片
    returnProductImgsFunc(e) {
      if (!e || e.length === 0) {
        this.isProductUpload = false;
        return;
      }
      
      // 验证图片格式
      const imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
      const invalidFiles = e.filter(element => {
        const data_array = element.file_path.split(".");
        const ext = data_array[data_array.length - 1].toLowerCase();
        return !imgExpt.includes(ext);
      });
      
      if (invalidFiles.length > 0) {
        this.$message.error("图片类型有误，请选择正确的图片格式");
        this.isProductUpload = false;
        return;
      }
      
      // 添加到对应的图片数组
      if (this.uploadType === 'image') {
        this.form.image = this.form.image.concat(e);
      } else if (this.uploadType === 'bannar') {
        this.form.bannar = this.form.bannar.concat(e);
      }
      
      this.isProductUpload = false;
    },
    
    // 删除图片
    deleteImg(index, type) {
      if (type === 'image') {
        this.form.image.splice(index, 1);
      } else if (type === 'bannar') {
        this.form.bannar.splice(index, 1);
      }
    },
    
    // 关闭弹窗
    dialogFormVisible() {
      this.$emit("close", { openDialog: false });
    },
    
    // 取消
    cancelFunc() {
      this.dialogFormVisible();
    },
    
    // 提交表单 - 使用通用API
    async onSubmit() {
      // 验证表单
      try {
        await this.$refs.formRef.validate();
      } catch (error) {
        return;
      }
      
      try {
        this.loading = true;
        
        // 处理其他职能字段
        const formData = {
          ...this.form,
          other_functions: this.formatOtherFunctions()
        };
        
        // 移除不需要的字段
        delete formData.other_functions_selected;
        delete formData.other_functions_custom;

 
        const response = await AfuncApi.call({
          model: 'ma_position',
          action: 'add',
          ...formData
        });
        
        if (response.code === 1) {
          this.$message.success(response.msg || '添加成功');
          this.dialogFormVisible();
        } else {
          this.$message.error(response.msg || '添加失败');
        }
      } catch (error) {
        console.error('添加失败:', error);
        this.$message.error('添加失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 格式化其他职能字段
    formatOtherFunctions() {
      let functions = [...this.form.other_functions_selected];
      
      if (this.form.other_functions_selected.includes('其他') && this.form.other_functions_custom) {
        const index = functions.indexOf('其他');
        if (index !== -1) {
          functions.splice(index, 1);
          functions.push(this.form.other_functions_custom);
        }
      }
      
      return functions.join(',');
    }
  }
};
</script>

<style scoped>
.pb50 {
  padding-bottom: 50px;
}

.upload-section {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 10px;
  background: #F5F7FA;
  margin-bottom: 15px;
}

.image-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.image-item {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  overflow: hidden;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-actions {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  padding: 2px;
}

.upload-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}

.common-button-wrapper {
  margin-top: 20px;
  text-align: center;
}

.el-row {
  margin-bottom: 15px;
}

.el-form-item {
  margin-bottom: 15px;
}

::v-deep .el-textarea__inner {
  font-family: inherit;
  line-height: 1.5;
}

::v-deep .el-tabs__item {
  padding: 0 20px;
}

::v-deep .el-tabs__header {
  margin-bottom: 15px;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 1px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/ma_position/index/part/add.vue